/* istanbul ignore next */
const ACTIONS = {
    FETCH_PAGE1_DATA_SUCCESS: 'FETCH_PAGE1_DATA_SUCCESS',
    FETCH_PAGE1_DATA_ERROR: 'FETCH_PAGE1_DATA_ERROR',

    POST_NAME: 'POST_NAME',
    POST_NAME_SUCCESS: 'POST_NAME_SUCCESS',
    POST_NAME_ERROR: 'POST_NAME_ERROR'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchPage1DataSuccess(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_SUCCESS,
            payload: {
                response
            }
        };
    },

    fetchPage1DataError(response) {
        return {
            type: ACTIONS.FETCH_PAGE1_DATA_ERROR,
            payload: {
                response
            }
        };
    },

    postName(name) {
        return {
            type: ACTIONS.POST_NAME,
            payload: {
                name
            }
        };
    },

    postNameSuccess(resp) {
        return {
            type: ACTIONS.POST_NAME_SUCCESS,
            payload: {
                resp
            }
        };
    },

    postNameError() {
        return {
            type: ACTIONS.POST_NAME_ERROR
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
